// ----------------------------------------------------------------------------
// Component: Blog Hero Carousel
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import Swiper, { Autoplay, Navigation, Pagination, Thumbs, A11y, Keyboard } from 'swiper';
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import 'snippets/swiper-control/swiper-control';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import 'swiper/css/thumbs';
import './_blog-hero-carousel.scss';


// -------------------------------------
// Variables
// -------------------------------------
const CAROUSEL_SECTION_SELECTOR = '.blog-hero-carousel';
const CAROUSEL_SELECTOR = '.carousel--blog-hero';
const CAROUSEL_CLASS = 'carousel--blog-hero';
const CAROUSEL_TAB_SELECTOR = '.carousel--blog-hero-tabs';
const CAROUSEL_TAB_CLASS = 'carousel--blog-hero-tabs';
const CAROUSEL_PREV_BUTTON_SELECTOR = '.swiper-button-prev';
const CAROUSEL_NEXT_BUTTON_SELECTOR = '.swiper-button-next';
const CAROUSEL_PAGINATION_SELECTOR = '.swiper-pagination';

// -------------------------------------
// Hooks
// -------------------------------------

document.querySelectorAll(CAROUSEL_SECTION_SELECTOR)
    .forEach((element, index) => {
        // Generate unique class for each collection list slider
        element.querySelector(CAROUSEL_SELECTOR)?.classList.add(`${CAROUSEL_CLASS}-${index}`);
        element.querySelector(CAROUSEL_TAB_SELECTOR)?.classList.add(`${CAROUSEL_TAB_CLASS}-${index}`);

        // Generate unique btn classes for slider arrows
        element.querySelector(CAROUSEL_PREV_BUTTON_SELECTOR)?.classList.add(`${CAROUSEL_CLASS}-btn-prev-${index}`);
        element.querySelector(CAROUSEL_NEXT_BUTTON_SELECTOR)?.classList.add(`${CAROUSEL_CLASS}-btn-next-${index}`);

        // Generate unique btn classes for swiper pagination
        element.querySelector(CAROUSEL_PAGINATION_SELECTOR)?.classList.add(`${CAROUSEL_CLASS}-pagination-${index}`);

        const slideTabs = element.querySelector(CAROUSEL_TAB_SELECTOR).querySelectorAll('.swiper-slide');

        let tabSlidesPerView = slideTabs.length > 0 ? slideTabs.length : 4;

        const swiperThumb = new Swiper(`.${CAROUSEL_TAB_CLASS}-${index}`, {
            // Optional parameters
            slidesPerView: tabSlidesPerView,
            spaceBetween: 0,
            freeMode: true,
            watchSlidesProgress: true,
        });

        const swiper = new Swiper(`.${CAROUSEL_CLASS}-${index}`, {
            // Optional parameters
            modules: [ Autoplay, Navigation, Pagination, Thumbs, A11y, Keyboard ],
            slidesPerView: 1,
            spaceBetween: 0,
            observer: true,
            observeParents: true,
            a11y: false,
            watchOverflow: true,
            autoHeight: false,

            autoplay: {
                delay: 5000,
                disableOnInteraction: true,
            },

            navigation: {
                nextEl: `.${CAROUSEL_CLASS}-btn-next-${index}`,
                prevEl: `.${CAROUSEL_CLASS}-btn-prev-${index}`
            },

            pagination: {
                el: `.${CAROUSEL_CLASS}-pagination-${index}`,
                type: 'bullets',
                clickable: true,
            },

            thumbs: {
                swiper: swiperThumb,
            },
        });

        swiper.slides.forEach(function(slide, index) {
            const slideLink = slide.querySelector('a');
            slideLink?.addEventListener('focus', function() {
                swiper.slideTo(index);
            });
        });
    });
